<template>
  <div class="commerce_page">
    <Breadcrumb :tabTitle="titleId"></Breadcrumb>
    <div class="meeting">
      <span v-if="type.length==0">暂无分类</span>
      <span v-for="(item, index) in type" @click="tabClick(item.article_id,item.article_name)" :key="index">{{item.article_name}}({{item.article_count}})</span>
    </div>
    <div class="com_box">
      <ListItem :classId="class_id" :search="search" :classIds="titleId" :title="name"></ListItem>
      <Rank></Rank>
    </div>
  </div>
</template>
<script>
import Breadcrumb from './Breadcrumb'
import Rank from './Rank'
import ListItem from './ListItem'
import axios from 'axios'
import Qs from 'qs'
export default {
  components: {
    Breadcrumb, Rank, ListItem
  },
  data(){
    return {
      type:[],
      name:'全部资讯',
      class_id:0,
      titleId:0,
      search:''
    }
  },
  created(){
    if(this.$route.query.id && this.$route.query.name){
      this.classId = this.$route.query.id;
      this.name = this.$route.query.name;
    }
    this.getCommentType();
  },
  methods:{
    tabClick(id,name){
      this.class_id = id;
      this.name = name;
    },
    getCommentType(){
      let url = encodeURI(`/ajax/App_ArchiveClass.ashx?class_id=${this.classId}&nums=10&action=article_count`)
      axios.post(url).then(res=>{
        this.type = res.data;
      })
    }
  },
  computed:{
    classId(){
      this.titleId = this.$route.params.id;
      if(this.$route.query.tid){
        this.class_id = this.$route.query.tid;
      }else{
        this.class_id = this.$route.params.id;
      }
      if(this.$route.query.name){
        this.name = this.$route.query.name;
      }else{
        this.name = '全部资讯';
      }
      return this.$route.params.id;
    },
    searchText(){
      this.search = this.$store.state.search;
      return this.$store.state.search;
    }
  },
  watch:{
    classId(){
      this.class_id = this.$route.params.id;
      if(this.$route.query.name){
        this.name = this.$route.query.name;
      }else{
        this.name = '全部资讯';
      }
      
      this.getCommentType();
    },
    searchText(){
      this.search = this.searchText;
    }
  }
}
</script>
<style scoped lang="scss">
.commerce_page {
  margin: 0 auto;
  width: 1200px;
  .meeting {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    border: 1px solid #c9deec;
    padding:10px;
    span {
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      font-size: 12px;
      color: #0053a4;
      width: 20%;
    }
    span:hover {
      color: #ff6c00;
    }
  }
  .com_box {
    display: flex;
    justify-content: space-between;
    
    
  }
  .page {
    height: 54px;
    display: flex;
    justify-content: flex-end;
    line-height: 54px;
    margin-top: 20px;
  }
}
</style>